// src/features/landing/components/VoucherFilterDrawer.jsx
"use client";

import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import VoucherFilters from "./VoucherFilters";

export default function VoucherFilterDrawer({
  isOpen,
  onClose,
  filters,
  setFilters,
  filterOptions,
  onReset,
  getCountryName,
}) {
  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="transition-opacity ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-30" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 flex justify-center items-end sm:items-center">
            <Transition.Child
              as={Fragment}
              enter="transition ease-in-out duration-300 transform"
              enterFrom="translate-y-full sm:translate-y-0 sm:scale-95"
              enterTo="translate-y-0 sm:scale-100"
              leave="transition ease-in-out duration-200 transform"
              leaveFrom="translate-y-0 sm:scale-100"
              leaveTo="translate-y-full sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="w-full sm:max-w-lg bg-surface text-textPrimary rounded-t-xl sm:rounded-xl p-4 overflow-y-auto max-h-[90vh] shadow-xl border border-border">
                <div className="flex justify-between items-center mb-4">
                  <h2 className="text-lg font-semibold text-textPrimary">Filters</h2>
                  <button
                    type="button"
                    onClick={onClose}
                    className="text-sm text-textPrimary underline"
                  >
                    Close
                  </button>
                </div>

                <VoucherFilters
                  filters={filters}
                  setFilters={setFilters}
                  filterOptions={filterOptions}
                  show={true}
                  onReset={onReset}
                  getCountryName={getCountryName}
                  variant="drawer"
                />

                <div className="mt-4 flex justify-between gap-2">
                  <button
                    type="button"
                    onClick={onReset}
                    className="flex-1 py-2 text-sm rounded bg-muted hover:bg-muted/80"
                  >
                    Reset
                  </button>
                  <button
                    type="button"
                    onClick={onClose}
                    className="flex-1 py-2 text-sm rounded bg-primary text-white hover:bg-accent"
                  >
                    Apply
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
